import { Company, User } from 'api/models';
import * as _ from 'lodash';
import { MeteorObservable } from 'meteor-rxjs';
import { Companies, Projects, Users } from 'api/collections';
import * as permissions from './permissions';
import { HttpService }  from './httpService';
import { Injectable, OnInit } from '@angular/core';
import { MeteorUser, AuthenticationService } from './congito';


@Injectable()
export class CompanyService {
  constructor(
    public httpService: HttpService,
    private authService: AuthenticationService
  ) {}

  getCompany(companyId: string) {
    // MeteorObservable.subscribe('companyDetails', companyId).subscribe();
    this.httpService.MeteorSubscribe('companyDetails', companyId);
    return Companies.findOne(companyId);
  }

  getCompanyProjects(company) {
    if (!company) {
      return;
    }
    return Projects.find({companyId: company._id, archived: {$ne: true}}, {sort: {name: 1}});
  }

  getCompanyAdmins(company) {
    if (!company || !company.adminIds) {
      return;
    }

    const { adminIds } = company;
    return Users.find({
      _id: {
        $in: adminIds,
      },
    }, {sort: {'profile.name': 1}}).fetch();
  }

  getCompanyMembers(company: void|Company): Array<User> {
    if (!company || !company.memberIds) {
      return;
    }

    const { memberIds } = company;
    const users = Users.find({
      _id: {
        $in: memberIds,
      },
    }, {sort: {'profile.name': 1}}).fetch();

    return users.sort((a,b)=>{
      return (permissions.isCompanyAdmin(company, b) ? 5 : 0) - (permissions.isCompanyAdmin(company, a) ? 5 : 0) + a.profile.name.localeCompare(b.profile.name)
    })
  }

  getUserCompanies(user: void|Meteor.User) {
    if (!user) {
      return;
    }
    // MeteorObservable.subscribe('userCompanies').subscribe();
    this.httpService.MeteorSubscribe('userCompanies')
    if((user as any).isSuperAdmin){
      // MeteorObservable.subscribe('allCompanies').subscribe();
      this.httpService.MeteorSubscribe('allCompanies');
      return Companies.collection.find({
      }, {sort: {'name': 1}}).fetch();
    }

    return Companies.collection.find({
      memberIds: user._id,
    }, {sort: {'name': 1}}).fetch();
  }

  subscribeActiveCompanyProjects() {
    return this.getCompanyProjects(this.subscribeActiveCompany());
  }

  subscribeActiveCompanyAdmins() {
    return this.getCompanyAdmins(this.subscribeActiveCompany());
  }

  subscribeActiveCompanyMembers() {
    return this.getCompanyMembers(this.subscribeActiveCompany());
  }

  subscribeActiveCompany(): Company|void {
    const viewer = MeteorUser();
    const activeCompanyId = viewer && viewer.profile && viewer.profile.activeCompanyId;

    if (!activeCompanyId) {
      return;
    }
    return this.getCompany(activeCompanyId);
  }
  async getCompanyPromise(companyId: string) {
    // MeteorObservable.subscribe('companyDetails', companyId).subscribe();
    await this.httpService.MeteorSubscribe('companyDetails', companyId);
    await this.httpService.privateLoopAction();
    const company =  Companies.findOne({_id:companyId});
    return company;
  }
  async subscribeActiveCompanyPromise(): Promise<Company|void> {
    const viewer = this.authService.MeteorUser();
    const activeCompanyId = viewer && viewer.profile && viewer.profile.activeCompanyId;

    if (!activeCompanyId) {
      return;
    }
    return this.getCompanyPromise(activeCompanyId);
  }
}



// WEBPACK FOOTER //
// ./src/services/companyData.ts